export default class PersianDate extends Date {
	getHijriDate = (options) => {
		//TODO update dateTime with real timezone
		return calculateDateDay(-1, options);
	};
	
	getParts = () => this.toLocaleDateString('fa-IR').split('/');
	getDay = () => super.getDay() === 6 ? 0 : super.getDay() + 1;
	getDate = () => this.getParts()[2];
	getMonth = () => this.getParts()[1] - 1;
	getYear = () => this.getParts()[0];
	getMonthName = () => this.toLocaleDateString('fa-IR', {month: 'long'});
	getDayName = () => this.toLocaleDateString('fa-IR', {weekday: 'long'});
}

function calculateDateDay(days = 0, options) {
	const myDate = new Date();
	myDate.setDate(myDate.getDate() + days);
	return myDate.toLocaleDateString('ar-SA', options);
}

function calculateDateMonth(months) {
	const myDate = new Date();
	myDate.setMonth(myDate.getMonth() + months);
	
	return myDate.toLocaleDateString('ar-SA', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	});
}

function calculateDateYear(years) {
	const myDate = new Date();
	myDate.setFullYear(myDate.getFullYear() + years);
	
	return myDate.toLocaleDateString('ar-SA', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	});
}
